import { Outlet } from "react-router-dom";

import Header from '../Components/Header'
import Sidebar from "../Components/Sidebar";

function Layout() {
  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="content-body">
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout
